<template>
  <div id="app" class="vbox">
    <div class="app-content">
      <router-view />
    </div>

    <my-footer></my-footer>
  </div>
</template>

<script>
import MyFooter from "@/components/Layout/Footer";
import firebase from "firebase/app";
import 'firebase/auth';
export default {
  name: "App",
  components: {
    MyFooter
  },
  mounted(){

    console.log('init firebase captcha');
    // Start Firebase invisible reCAPTCHA verifier
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('get-sign-in-code', {
      size: 'invisible',
      callback: () => {
        // reCAPTCHA solved, allow signInWithPhoneNumber.
        console.log('ok ready now');
        // self.showLogin();
      },
    });

    window.recaptchaVerifier.render().then((widgetId) => {
      window.recaptchaWidgetId = widgetId;
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue